export enum AuditTabEvent {
    FetchAllRecords = 'AuditTab.DataFetchAllRecords',
    FetchRowRecord = 'AuditTab.DataFetchRowRecord',
    SearchAuditRecords = 'AuditTab.SearchAuditRecords',
    GeneratedExport = 'AuditTab.GeneratedExport',
    DownloadedExport = 'AuditTab.DownloadedExport',
    ViewExport = 'AuditExportTab.ViewExport',
    FailedExport = 'AuditExportTab.FailedExport',
}
